import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserBetrieb } from '../data/user/user-betrieb.model';
import { WindRichtlinienab } from '../data/ws/wind-richtlinienab.model';
import { Gebietskategorie } from '../data/ws/gebietskategorie.model';
import { MainComponent } from '../components/pages/anwendung/main/main.component';
import { BetriebComponent } from '../components/blocks/tabs/betrieb/betrieb.component';
import { WinddatenGebietskategorieComponent } from '../components/blocks/tabs/winddaten-gebietskategorie/winddaten-gebietskategorie.component';
import { Tierart } from '../data/ws/tierart.model';
import { Tierkategorie } from '../data/ws/tierkategorie.model';
import { MinderungsmassnahmeTierkategorie } from '../data/ws/minderungsmassnahme-tierkategorie.model';
import { MinderungsmassnahmeFlaeche } from '../data/ws/minderungsmassnahme-flaeche.model';
import { TkHvGeruchsemission } from '../data/ws/tk-hv-geruchsemission.model';
import { Flaechenquellart } from '../data/ws/flaechenquellart.model';
import { AppComponent } from '../app.component';
import { ErgebnisBetrieb } from '../data/ws/ergebnis-betrieb.model';

@Injectable({
  providedIn: 'root'
})
export class LocalService {
  public appComponentRef: BehaviorSubject<AppComponent | null> = new BehaviorSubject<AppComponent | null>(null);
  public mainComponentRef: BehaviorSubject<MainComponent | null> = new BehaviorSubject<MainComponent | null>(null);
  public betriebComponentRef: BehaviorSubject<BetriebComponent | null> = new BehaviorSubject<BetriebComponent | null>(null);
  public winddatenGebietskategorieComponentRef: BehaviorSubject<WinddatenGebietskategorieComponent | null> = new BehaviorSubject<WinddatenGebietskategorieComponent | null>(null);

  public tierartList: BehaviorSubject<Tierart[] | null> = new BehaviorSubject<Tierart[] | null>(null);
  public tierkategorieList: BehaviorSubject<Tierkategorie[] | null> = new BehaviorSubject<Tierkategorie[] | null>(null);
  public minderungsmassnahmeTierkategorieList: BehaviorSubject<MinderungsmassnahmeTierkategorie[] | null> = new BehaviorSubject<MinderungsmassnahmeTierkategorie[] | null>(null);
  public minderungsmassnahmeFlaechenList: BehaviorSubject<MinderungsmassnahmeFlaeche[] | null> = new BehaviorSubject<MinderungsmassnahmeFlaeche[] | null>(null);
  public tkHvGeruchsemissionList: BehaviorSubject<TkHvGeruchsemission[] | null> = new BehaviorSubject<TkHvGeruchsemission[] | null>(null);
  public flaechenquellartList: BehaviorSubject<Flaechenquellart[] | null> = new BehaviorSubject<Flaechenquellart[] | null>(null);

  public ergebnisBetrieb = new BehaviorSubject<ErgebnisBetrieb>(null);

  public aktuellerUserBetrieb = new BehaviorSubject<UserBetrieb>(new UserBetrieb());
  public isBetriebValid = new BehaviorSubject<boolean>(false);
  public windRichtlinienabList = new BehaviorSubject<WindRichtlinienab[]>([]);
  public globalWSData = new BehaviorSubject<Gebietskategorie[]>([]);

  updateBezeichnung(bezeichnung: string) {
    const current = this.aktuellerUserBetrieb.value;

    this.aktuellerUserBetrieb.next({
      ...current,
      bezeichnung
    });

  }

  updateBeschreibung(beschreibung: string) {
    const current = this.aktuellerUserBetrieb.value;

    this.aktuellerUserBetrieb.next({
      ...current,
      beschreibung
    });
  }

  updateGewichtungsfaktor(gewichtungsfaktor: number) {
    const current = this.aktuellerUserBetrieb.value;

    this.aktuellerUserBetrieb.next({
      ...current,
      gewichtungsfaktor
    });
  }

  updateZusatzabstand(zusatzabstand: number) {
    const current = this.aktuellerUserBetrieb.value;

    this.aktuellerUserBetrieb.next({
      ...current,
      zusatzabstand
    });
  }
}